import React from 'react'
import LoginPage from '../components/Login/LoginPage'
import Navbar from '../components/Navbar/Navbar'

const Login = () => {
  return (
    <>
    <Navbar />
    <LoginPage />
    </>
  )
}

export default Login